"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import VadImage from "vadimages-nextjs-image-optimizer";

const certifications = [
  {
    imgName: "iso-9001.png",
    imgWidth: 120,
    imgHeight: 120,
  },
  {
    imgName: "iso-14001.png",
    imgWidth: 120,
    imgHeight: 120,
  },
  {
    imgName: "iso-45001.png",
    imgWidth: 120,
    imgHeight: 120,
  },
  {
    imgName: "cgmp-820.png",
    imgWidth: 107,
    imgHeight: 107,
  },
  {
    imgName: "cgmp-110.png",
    imgWidth: 107,
    imgHeight: 107,
  },
  {
    imgName: "iso-13485.png",
    imgWidth: 135,
    imgHeight: 135,
  },
  {
    imgName: "haccp.png",
    imgWidth: 120,
    imgHeight: 120,
  },
];

const imageDirectory = "/images/process-certifications/";

export const ProcessCertificationsLogos = () => (
  <div className="flex gap-2.5 w-fit mx-auto max-md:flex-wrap max-md:justify-around">
    {certifications.map((c) => (
      <VadImage
        key={`certificate-${c.imgName}`}
        src={`${imageDirectory}${c.imgName}`}
        alt={c.imgName}
        width={c.imgWidth}
        height={c.imgHeight}
      />
    ))}
  </div>
);

export const ProcessCertifications = () => {
  const { certificationsHeadline, certificationsBody, processCertifications } =
    useTranslations();
  return (
    <section className="mt-16 mb-4">
      <div className="text-center [&>*]:mx-auto">
        <h2 className="max-w-[850px] mb-4">{certificationsHeadline}</h2>
        <p className="max-w-[570px] mb-20">{certificationsBody}</p>
      </div>
      <p className="text-center font-semibold text-sm tracking-widest uppercase mb-2.5">
        {processCertifications}
      </p>
      <ProcessCertificationsLogos />
    </section>
  );
};
